import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { toasterMsg } from '../Components/Toaster/Toaster';

export const fetchProductHistoryService = async (devorderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_HISTORY.GET_LIST}/${devorderId}`);
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
  }
};

export const fetchProductHistoryListService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_HISTORY.GENERATE_CHANGES}/${data.devOrderId}`, { params: { ...data } });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
  }
};
